'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../common/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import '../css/custom_admin.css'

var Contact = function (_Component) {
    _inherits(Contact, _Component);

    function Contact(props) {
        _classCallCheck(this, Contact);

        var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));

        _this.inviteUser = function (meetingId, userId) {
            var self = _this;
            console.log("Meeting Id : ", meetingId, "  User Id : ", userId);

            console.log("Invitation send to user " + userId + " to meeting " + meetingId);
            var joinChatUrl = window.sfChat.baseApiUrl + "/v1/meeting/" + meetingId + "/invite";
            var headers = (0, _helpers.getAuthHeader)();
            fetch(joinChatUrl, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ invitees: [userId] })
            }).then(function (response) {
                return response.json();
            }).then(function (res) {
                if (res.status === "success") {
                    console.log("Invited user successfully");
                    self.setState({
                        invitedContact: true
                    });
                } else {
                    console.log("Unable to invite user");
                }
            }).catch(function (err) {
                console.log("inviteUserRequest failed " + err);
            });
        };

        _this.state = {
            invitedContact: false
        };
        return _this;
    }

    _createClass(Contact, [{
        key: 'onInviteClick',
        value: function onInviteClick(contactId) {

            this.inviteUser(this.props.meetingId, contactId);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var self = this;
            if (this.state.invitedContact === true) {
                setTimeout(function () {
                    self.setState({
                        invitedContact: false
                    });
                }, 5000);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var online_status = this.props.contact.online_status ? _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('i', { className: 'fa fa-circle text-success' }),
                ' Online'
            ) : _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('i', { className: 'fa fa-circle text-danger' }),
                ' Offline'
            );

            var inviteButton = null;
            if (this.state.invitedContact === false) {
                inviteButton = _react2.default.createElement(
                    'button',
                    { className: 'pull-right btn btn-link', style: { color: '#000000' }, onClick: this.onInviteClick.bind(this, this.props.contact.id) },
                    'Invite'
                );
            } else {
                inviteButton = _react2.default.createElement(
                    'span',
                    { className: 'pull-right btn', style: { color: '#000000' } },
                    'Invited User'
                );
            }

            return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement('img', { className: 'contacts-list-img', src: 'https://www.imran.com/xyper_images/icon-user-default.png', alt: 'user pic' }),
                _react2.default.createElement(
                    'div',
                    { className: 'contacts-list-info' },
                    _react2.default.createElement(
                        'span',
                        { className: 'contacts-list-name', style: { color: '#000000' } },
                        this.props.contact.name
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'contacts-list-msg' },
                        online_status
                    ),
                    inviteButton
                )
            );
        }
    }]);

    return Contact;
}(_react.Component);

exports.default = Contact;


// WEBPACK FOOTER //
// ../chat/lib/components/contacts/contact.js